module.exports = __webpack_public_path__ + "static/news5pic4-40d4a3dc591ce9979600ead2e239901e.jpg";